import React from 'react';
import { ViewStyle, Text, View } from 'react-native';
import { Hr, sectionListStyles } from 'LocalGluons';

import defaultStyles from './AccountInfoListItem.jss';

interface AccountInfoListItemProps {
    name: string;
    description?: string | Array<string>;
    sectionContainer?: ViewStyle;
}

const AccountInfoListItem = ({
    name,
    description = '',
    sectionContainer
}: AccountInfoListItemProps): React.ReactElement => (
    <View style={defaultStyles.outerItemContainer}>
        <>
            <View style={[defaultStyles.innerItemContainer, sectionContainer]}>
                <Text
                    style={[
                        sectionListStyles.itemName,
                        defaultStyles.itemName,
                        description ? defaultStyles.itemNameWithDescription : {}
                    ]}
                    numberOfLines={1}
                >
                    {name}
                </Text>
                {description ? (
                    <Text style={[sectionListStyles.header, defaultStyles.itemDescription]}>
                        {description}
                    </Text>
                ) : null}
            </View>
            <Hr />
        </>
    </View>
);

export default AccountInfoListItem;
